const angularValidators = {
  'required': '必填',
  'minlength': '最小字元长度：{{requiredLength}}，当前字元长度：{{actualLength}}',
  'maxlength': '最大字元长度：{{requiredLength}}，当前字元长度：{{actualLength}}',
  'min': '最小值：{{min}}，当前值：{{actual}}',
  'max': '最大值：{{max}}，当前值：{{actual}}',
  'requiredtrue': '必为真(true)',
  'email': '不符合电子邮件格式',
  'pattern': '格式不匹配{{requiredPattern}}',
  'nullValidator': '无操作验证器',
  'response': '{{message}}'
};

const dwI18nProgView = {
  'dw-login-rememberMe': 'Ghi nhớ tôi',
  'dw-login-forgetPassword': 'Quên mật khẩu',
  'dw-login-registered': 'Đăng ký',
  'dw-login-password': 'Mật khẩu',
  'dw-login-account': 'Tài khoản',
  'dw-login-signIn': 'Đăng nhập',
  'dw-login-tenant': 'Trang chủ',
  'dw-sys-menu-save': 'Lưu',
  'dw-sys-menu-cancel': 'Hủy bỏ',
  'dw-sys-menu-add': 'Mới',
  'dw-sys-menu-increase': 'Thêm',
  'dw-sys-menu-edit': 'Chỉnh sửa',
  'dw-sys-menu-delete': 'Xoá',
  'dw-sys-menu-addItem': 'Dự án mới',
  'dw-sys-menu-externalLink': 'Liên kết ngoài',
  'dw-sys-menu-category': 'Thư mục',
  'dw-sys-menu-program': 'Công việc',
  'dw-sys-menu-report': 'Báo cáo',
  'dw-sys-menu-menuPreview': 'Xem thử menu',
  'dw-sys-menu-name': 'Hiện tên',
  'dw-sys-menu-iconClass': 'Kiểu biểu tượng',
  'dw-sys-menu-defaultExpand': 'Mở rộng mặc định',
  'dw-sys-menu-nodeEditing': 'Chỉnh sửa nút',
  'dw-sys-menu-linkProgram': 'Liên kết công việc',
  'dw-sys-menu-parameterSetting': 'Thiết lập tham số',
  'dw-sys-menu-parameterName': 'Tên tham số',
  'dw-sys-menu-parameterValue': 'Giá trị tham số',
  'dw-sys-menu-linkURL': 'Địa chỉ liên kết',
  'dw-sys-menu-openMode': 'Cách mở',
  'dw-sys-menu-openMode-window': 'Mở cửa sổ khác',
  'dw-sys-menu-openMode-iframe': 'Nhúng trang Web',
  'dw-sys-menu-upload-mcc': 'Tải lên ứng dụng kết nối',
  'dw-sys-menu-upload-mcc-hint': 'Tải lên tất cả các ứng dụng kết nối',
  'dw-sys-menu-msg-updateFailed': 'Cập nhật thất bại',
  'dw-sys-menu-msg-updated': 'Đã cập nhật',
  'dw-sys-menu-msg-confirmDelete': 'Bạn có xóa thư mục và các liên kết có liên quan không?',
  'dw-sys-menu-msg-deleteFailed': 'Lỗi xóa',
  'dw-sys-menu-msg-deleted': 'Đã xoá',
  'dw-sys-menu-msg-notExist': '{{value1}} Không có thông tin',
  'dw-sys-menu-msg-exist': 'Đừng lặp lại cài đặt',
  'dw-forget-mailCode': 'Mã xác nhận mail',
  'dw-forget-mobileCode': 'Điện thoại Captcha',
  'dw-forget-enterEmailReceive': 'Vui lòng nhập email của bạn để nhận email mở tài khoản',
  'dw-forget-enterCorrectEmail' : 'Vui lòng nhập email chính xác',
  'dw-forget-emailNotExist': 'Email không tồn tại',
  'dw-forget-enterCellphone': 'Vui lòng nhập số điện thoại di động của bạn',
  'dw-forget-needsDigits': 'Số điện thoại phải có 11 chữ số.',
  'dw-forget-needAllNumbers': 'Số điện thoại phải là số',
  'dw-forget-cellphoneNotExist': 'Số điện thoại không tồn tại',
  'dw-forget-getCode': 'Nhận CAPTCHA',
  'dw-forget-enterCode': 'Vui lòng nhập CAPTCHA',
  'dw-forget-countDown': '{{current}} Đếm ngược giây',
  'dw-forget-newPassword': 'Mật khẩu mới',
  'dw-forget-confirmNewPassword': 'Xác nhận mật khẩu mới',
  'dw-forget-enterNewPassword': 'Vui lòng nhập mật khẩu mới',
  'dw-forget-enterNewPasswordAgain': 'Vui lòng nhập lại mật khẩu mới',
  'dw-forget-passwordMismatch': 'Mật khẩu không khớp',
  'dw-forget-sentSuccessfully': 'Gửi thành công',
  'dw-forget-confirmCodeMailbox': 'Vui lòng xác nhận hộp thư CAPTCHA',
  'dw-forget-confirmCodeSMS': 'Vui lòng xác nhận SMS CAPTCHA',
  'dw-forget-logInAgain': 'Sau khi thay đổi mật khẩu, vui lòng đăng nhập lại bằng mật khẩu mới',
  'dw-forget-updatedSuccessfully': 'Cập nhật mật khẩu thành công, vui lòng đăng nhập bằng mật khẩu mới'
};

export const dwI18nBasic = {
  ...angularValidators,
  ...dwI18nProgView,
  'app-title': '',
  'dw-request-url': 'Yêu cầu địa chỉ web',
  'dw-request-body': 'Nội dung yêu cầu',
  'dw-response-status': 'Trạng thái phản hồi',
  'dw-response-message': 'Trả lời tin nhắn',
  'dw-http-error': 'Xin lỗi, có gì đó không ổn.',
  'dw-http-error-400': 'Yêu cầu sai',
  'dw-http-error-401': 'Yêu cầu gửi thiếu chứng từ',
  'dw-http-error-403': 'Xin lỗi, bạn không có quyền truy cập trang này',
  'dw-http-error-404': 'Xin lỗi, trang bạn đang truy cập không tồn tại',
  'dw-http-error-500': 'Xin lỗi, máy chủ bị lỗi',
  'dw-loadingData': 'Đang tải dữ liệu',
  'dw-pleaseEnter': 'Vui lòng nhập chuỗi tìm kiếm',
  'dw-determine': 'Xác định',
  'dw-cancel': 'Hủy bỏ',
  'dw-save': 'Lưu',
  'dw-select-modal-error-dataSource': 'Cần có nguồn',
  'dw-select-modal-error-tableIdField': 'Trường id được sử dụng không được rỗng',
  'dw-select-modal-error-tableNameField': 'Trường name được sử dụng không được rỗng',
  'dw-select-modal-error-tableColDefs': 'Các trường bảng không được xác định là giá trị trống',
  'dw-select-modal-error-tableColDefs-title': 'Định nghĩa trường bảng - [title] không được null',
  'dw-select-modal-error-tableColDefs-field': 'Định nghĩa trường bảng - [field] không được rỗng',
  'dw-hello':"Xin chào",
  'dw-welcome': "Chào mừng đến với",
  'dw-login':"Đăng nhập",
  'dw-login-mobile':"Click vào Login Mobile End",
  'dw-download-chrome':"Click để tải về Google Browser",
  'dw-WeChat-QRCode':"WeChat lướt qua",
  'dw-WeChatOffice-QRCode':"WeChat của doanh nghiệp",
  'dw-DingTaik-QRCode':"Quét móng tay."
};
